import React, { useEffect, useMemo, useState } from "react";
import { Alert, Empty, Table } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import FooterTableTimekeeping from "../../components/hrm/timekeeping/time-sheet/timesheet-viewport/FooterTable";
import { LoadingOutlined } from "@ant-design/icons";
import SearchEmpty from "./data/SearchEmpty";
import Nodata from "./data/NoData";
import PropTypes from "prop-types";

const CommonList = ({
    hasIndex,
    columns,
    dataSource,
    totalCount,
    loading,
    title,
    hasFilterStatus,
    onChange,
    height,
    footerTable,
    notAbsolute,
    paginationConfig,
    tabKey,
    shiftRegistration = false,
    ...rest
}) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [thisColumns, setThisColumns] = useState(columns);
    const PAGE_SIZE = shiftRegistration == false ? "pageSize" : "pageShiftSize"
    const PAGE = shiftRegistration == false ? "page" : "pageShift"
    const [totalPerPage, setTotalPerPage] = useState(searchParams?.get(PAGE_SIZE) || 0);
    useEffect(() => {
        if (hasIndex) {
            setThisColumns([
                {
                    dataIndex: "index",
                    title: t("shiftRegistrationTitle.STT"),
                    width: "80px",
                    align: "center",
                    render: (text, record, index) => (
                        <>
                            {JSON.parse(searchParams.get(PAGE_SIZE) || 20) *
                                (JSON.parse(searchParams.get(PAGE) || 1) -
                                    1) +
                                index +
                                1}
                        </>
                    ),
                },
                ...columns,
            ]);
        } else {
            setThisColumns(columns); //todo important
        }
    }, [
        hasIndex,
        searchParams.get(PAGE_SIZE),
        searchParams.get(PAGE),
        columns,
    ]);

    const showTotal = (total, range) => {
        return `${range[0]} - ${range[1]} ${t(
            "tnp.common.layout.list.total"
        )} ${total}`;
    };

    function onChangeTable(pagination, filters, sorter, extra) {
        const page = pagination.current;
        const pageSize = pagination.pageSize;
        const sortField = sorter.field;
        const sortOrder = sorter.order;

        setTotalPerPage(pagination.pageSize);

        searchParams.set(PAGE, page);
        searchParams.set(PAGE_SIZE, pageSize);

        if (!!sortOrder) {
            searchParams.set(
                "sort",
                `${sortField}:${sortOrder.replace("end", "")}`
            );
        } else {
            searchParams.delete("sort");
        }

        navigate(`?${searchParams.toString()}`);

        if (onChange) {
            onChange(pagination, filters, sorter, extra);
        }
    }

    const sticky = useMemo(() => {
        return {
            getContainer: () => {
                return document.getElementsByClassName("wrapper-class-list")[0];
            },
        };
    }, []);
    return (
        <>
            {dataSource?.length > 0 ? (
                <div
                    className={
                        "custom-table relative  bg-white rounded-bl-[12px] rounded-br-[12px] overflow-hidden"
                    }
                    style={{
                        borderRight: "1px solid #EAECF0",
                        borderLeft: "1px solid #EAECF0",
                        borderBottom: "1px solid #EAECF0",
                        height: height || "93%",
                    }}
                >
                    <div
                        className={"h-[90%] overflow-auto wrapper-class-list overflow-x-hidden"}
                    >
                        <Table
                            columns={thisColumns}
                            dataSource={dataSource}
                            onChange={onChangeTable}
                            title={title}
                            pagination={{
                                total: totalCount,
                                showTotal: showTotal,
                                showSizeChanger: true,
                                pageSizeOptions: [4, 8, 10, 20, 30],
                                pageSize: JSON.parse(
                                    searchParams.get(PAGE_SIZE) || 20
                                ),
                                current: JSON.parse(
                                    searchParams.get(PAGE) || 1
                                ),
                                hideOnSinglePage:
                                    !searchParams.get(PAGE) ||
                                    searchParams.get(PAGE_SIZE) <= 20,
                                className: notAbsolute
                                    ? ""
                                    : "absolute" +
                                    " bottom-0 bg-white right-0 left-0 text-right p-3 !m-0",

                                ...paginationConfig,
                            }}
                            loading={loading}
                            rowClassName={`${rest?.rowClassName} max-h-[64px] h-[56px] overflow-hidden`}
                            locale={{
                                emptyText: (
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={t("common.noData")}
                                    />
                                ),
                            }}
                            sticky={sticky}
                            {...rest}
                        />
                    </div>


                    {footerTable ? <FooterTableTimekeeping /> : <></>}
                    {dataSource &&
                        dataSource?.length > 0 &&
                        dataSource[0]?.enabled &&
                        searchParams.get("view-shift-work") && (
                            <div
                                className={
                                    " flex items-center footer-table bottom-4 absolute pl-6 pt-2 "
                                }
                            >
                                <Alert
                                    message={t(
                                        "tnp.common.layout.list.message"
                                    )}
                                    type="info"
                                    icon={<LoadingOutlined />}
                                    showIcon
                                />
                            </div>
                        )}
                </div>
            ) : (
                <>
                    {searchParams.get("search") ? (
                        <SearchEmpty searchValue={searchParams.get("search")} />
                    ) : (
                        <Nodata loading={loading} tabKey={tabKey} />
                    )}
                </>
            )}
        </>
    );
};

CommonList.propTypes = {
    hasIndex: PropTypes.bool,
    columns: PropTypes.array,
    dataSource: PropTypes.array,
    totalCount: PropTypes.number,
    loading: PropTypes.bool,
    title: PropTypes.func,
    hasFilterStatus: PropTypes.bool,
    onChange: PropTypes.func,
    height: PropTypes.string,
    footerTable: PropTypes.bool,
    notAbsolute: PropTypes.bool,
    paginationConfig: PropTypes.object,
    tabKey: PropTypes.string,
};

export default CommonList;
